// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__GkT4F","noInteraction":"EventWrapper_noInteraction__1d3PU","pointerPassthrough":"EventWrapper_pointerPassthrough__2ma9w"};